const doc = [({"da":({"js":({"admin":({"bundles":({"select":({"choose_bundle":"Vælg pakke"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;